import http from "infra/http";
import { useMutation } from "react-query";

function useDeleteGrupoDesconto() {
  return useMutation(
    `/v1/grupo-desconto/deletar`,
    async (id: string) => {
      
      const { data } = await http.delete(`/v1/grupo-desconto/${id}`);

      return data;
    },
  );
}

export default useDeleteGrupoDesconto;
